/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'antd';
import { DivStyled, ContainerStyled, ContainFormRight } from './styled';
import GoogleMaps from './components/GoogleMaps';
import ZoneEditorForm from '../ZoneEditorForm';
import { Header, Title } from '$app/shared/components/Header';
import { getDriverCoverage, createDriverCoverage, getDriverZoneShapes, updateDriverZone } from './actions';

function GarageCoveragePage({ history, match }) {
  const ownerId = match.params.ownerId;
  const [coverage, setCoverage] = useState(null);
  const [driverZonesCoverage, setDriverZonesCoverage] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);

  let getFieldsValue = () => console.log('uninitialised');

  useEffect(() => {
    getDriverCoverage(ownerId).then((driverCoverage) => setCoverage(driverCoverage));
    // filter out the current driverzone to exclude the shape
    getDriverZoneShapes().then((data) =>
      setDriverZonesCoverage(data.filter((area) => area.ownerId !== ownerId))
    );
  }, [ownerId]);

  const updateCoverage = useCallback(
    (mapData) => {
      const formValues = getFieldsValue();
      formValues.metadata = { status: formValues.status };

      createDriverCoverage({ ...mapData, ...formValues });
      const oldCoverage = { ...coverage };
      oldCoverage.geoJson = mapData.geoJson;
      setCoverage(oldCoverage);
      setShowSidebar(false);
    },
    [coverage]
  );

  const cancelCoverageEdits = useCallback(() => setCoverage({ ...coverage }), [coverage]);

  const closePageHandler = useCallback(() => history.push('/'), [history]);

  const getValuesWrapper = (getFieldsValueFunc) => {
    getFieldsValue = getFieldsValueFunc;
  };

  const toggleSidebar = (visible) => setShowSidebar(visible);

  return (
    <ContainerStyled>
      <Header className="justify">
        <Title>
          Driver zone {coverage ? coverage.name : 'loading...'}
          <Button type="link" onClick={closePageHandler} className="pull-right">
            <img alt="close" src="/assets/images/close-black.svg" style={{ cursor: 'pointer', height: 20 }} />
          </Button>
        </Title>
      </Header>
      <DivStyled>
        {coverage && (
          <>
            <GoogleMaps
              updateCoverage={updateCoverage}
              cancelCoverageEdits={cancelCoverageEdits}
              driverZonesCoverage={driverZonesCoverage}
              zone={{ ownerId, coverage }}
              setShowSidebar={(visible) => toggleSidebar(visible)}
            />
            <ContainFormRight style={{ display: !showSidebar && 'none' }}>
              <ZoneEditorForm
                onSuccess={(data) => updateDriverZone(ownerId, data)}
                getValues={getValuesWrapper}
                editing
                data={{
                  name: coverage.name,
                  status: coverage.status,
                  segment: coverage.segment,
                }}
              />
            </ContainFormRight>
          </>
        )}
      </DivStyled>
    </ContainerStyled>
  );
}

export default withRouter(GarageCoveragePage);
